export default __webpack_public_path__ + "static/media/car12.bcc272fa.jpg";